// extracted by mini-css-extract-plugin
module.exports = {"home":"style_home__8uDly","home__content":"style_home__content__ronzG"};